import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';

const MorningAfternoonNav = props => {
    const { currentTime, color, language, timeNavigation } = props;
    return (
        <nav className="morning-afternoon-menu day-nav">
            <ul>
                <li>
                    <a
                        style={
                            currentTime === 'morning' || !currentTime
                                ? { color }
                                : null
                        }
                        onClick={() => timeNavigation('morning')}
                    >
                        {translate(language, 'morning')}
                    </a>
                </li>
                <li>
                    <a
                        style={currentTime === 'afternoon' ? { color } : null}
                        onClick={() => timeNavigation('afternoon')}
                    >
                        {translate(language, 'afternoon')}
                    </a>
                </li>
            </ul>
        </nav>
    );
};

MorningAfternoonNav.propTypes = {
    currentTime: PropTypes.string,
    timeNavigation: PropTypes.func,
    color: PropTypes.string,
    dayNavColor: PropTypes.string,
};

export default MorningAfternoonNav;



// WEBPACK FOOTER //
// ./src/partials/MorningAfternoonNav.js